export default "__VITE_ASSET__BXXJOWpm__"